import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { eventManageAdd, eventManageUpd } from "@/api/financial/backhaul";
export default {
  props: {
    advertChannelData: {
      type: Array,
      data: function data() {
        return '';
      }
    }
  },
  data: function data() {
    return {
      dialogFormVisible: false,
      formData: {
        id: "",
        event_name: "",
        event_mark: '',
        advert_channel_id: ""
      },
      rules: {
        event_name: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }],
        event_mark: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }],
        advert_channel_id: [{
          required: true,
          message: "请选择",
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {},
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.dialogFormVisible = true;

                if (data) {
                  _this.formData = _objectSpread({}, data);
                }

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    resetForm: function resetForm(formName) {
      this.dialogFormVisible = false;
      this.formData.id = '';
      this.clearData();
    },
    dataFormSubmit: function dataFormSubmit(formName) {
      var _this2 = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          var req = _this2.formData.id ? eventManageUpd : eventManageAdd;
          req(_objectSpread({}, _this2.formData)).then(function (res) {
            if (res.status == 200) {
              _this2.$Message.success('操作成功');

              _this2.$emit("refreshDataList");

              _this2.resetForm("ruleForm");
            }
          });
        }
      });
    },
    clearData: function clearData() {
      this.formData = {
        id: this.formData.id,
        client_id: "",
        client_secret: '',
        advert_channel_id: ""
      };
      this.$refs.ruleForm.resetFields();
    }
  }
};